/**
 * Single-product pack selector — syncs pack cards with WooCommerce variation markup.
 */
function parseVariations(form) {
	const raw = form.getAttribute('data-product_variations');
	if (!raw) {
		return [];
	}
	try {
		return JSON.parse(raw);
	} catch (e) {
		return [];
	}
}

function stockMarkup(variation, labels) {
	if (!variation) {
		return { className: '', text: '' };
	}
	if (variation.in_stock) {
		return { className: 'in-stock', text: labels.inStock || 'In stock' };
	}
	if (variation.backorders_allowed) {
		return { className: 'available-on-backorder', text: labels.backorder || 'Available on backorder' };
	}
	return { className: 'out-of-stock', text: labels.outOfStock || 'Out of stock' };
}

function applySelection(form, variationId) {
	const variations = parseVariations(form);
	const variation = variations.find((v) => Number(v.variation_id) === Number(variationId));
	if (!variation || !variation.purchasable) {
		return;
	}

	const labels = (window.wcQuickBuySettings && window.wcQuickBuySettings.config && window.wcQuickBuySettings.config.labels) || {};

	form.querySelectorAll('[data-action="select-pack"]').forEach((btn) => {
		const selected = Number(btn.getAttribute('data-variation-id')) === Number(variationId);
		btn.classList.toggle('is-selected', selected);
		btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
	});

	const variationIdInput = form.querySelector('input.variation_id');
	if (variationIdInput) {
		variationIdInput.value = String(variation.variation_id);
	}

	Object.entries(variation.attributes || {}).forEach(([key, value]) => {
		const attrKey = key.replace(/^attribute_/, '');
		const field =
			form.querySelector(`input[name="attribute_${attrKey}"]`) ||
			form.querySelector(`input[data-attribute_name="attribute_${attrKey}"]`) ||
			form.querySelector(`input[name="attribute_${key}"]`);
		if (field) {
			field.value = value;
		}
	});

	const wrap = form.querySelector('.woocommerce-variation.single_variation');
	if (wrap) {
		wrap.style.display = '';
	}

	const priceEl = form.querySelector('.woocommerce-variation-price');
	if (priceEl) {
		priceEl.innerHTML = variation.price_html
			? `<span class="price">${variation.price_html}</span>`
			: '';
	}

	const availability = form.querySelector('.woocommerce-variation-availability');
	if (availability) {
		const stock = stockMarkup(variation, labels);
		availability.innerHTML = stock.text
			? `<p class="stock ${stock.className}">${stock.text}</p>`
			: '';
	}

	const qty = form.querySelector('input.qty');
	if (qty) {
		qty.disabled = false;
		if (variation.max_qty !== null && variation.max_qty !== undefined) {
			qty.max = String(variation.max_qty);
			if (Number(qty.value) > Number(variation.max_qty)) {
				qty.value = String(variation.max_qty);
			}
		} else {
			qty.removeAttribute('max');
		}
	}

	const buttonWrap = form.querySelector('.woocommerce-variation-add-to-cart');
	const submit = form.querySelector('.single_add_to_cart_button');
	if (buttonWrap) {
		buttonWrap.classList.add('woocommerce-variation-add-to-cart-enabled');
		buttonWrap.classList.remove('woocommerce-variation-add-to-cart-disabled');
	}
	if (submit) {
		submit.disabled = false;
		submit.classList.remove('disabled', 'wc-variation-is-unavailable');
	}

	const payload = {
		variation_id: variation.variation_id,
		price_html: variation.price_html,
		is_in_stock: variation.in_stock,
		is_purchasable: variation.purchasable,
		variation_is_active: true,
		variation_is_visible: true,
		attributes: variation.attributes || {},
	};

	form.dispatchEvent(
		new CustomEvent('wcVariationSelector:variationSelected', {
			bubbles: true,
			detail: {
				productId: Number(form.getAttribute('data-product_id')),
				variationId: Number(variation.variation_id),
				optionLabel: variation.label || '',
			},
		})
	);

	// Compatibility bridge for theme / TI Wishlist (listens for show_variation).
	if (window.jQuery) {
		const $form = window.jQuery(form);
		$form.trigger('found_variation', [payload]);
		$form.trigger('show_variation', [payload, true]);
	}
}

function bindForm(form) {
	form.addEventListener('click', (event) => {
		const button = event.target.closest('[data-action="select-pack"]');
		if (!button || !form.contains(button)) {
			return;
		}
		event.preventDefault();
		if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
			return;
		}
		applySelection(form, button.getAttribute('data-variation-id'));
	});
}

export function initVariationSelectors(root = document) {
	root.querySelectorAll('form.wcqb-variation-selector').forEach((form) => {
		if (form.dataset.bcPackBound === '1') {
			return;
		}
		form.dataset.bcPackBound = '1';
		bindForm(form);
	});
}
